import { max, min } from "./math.es.js";
function within(min$1, value, max$1) {
  return max(min$1, min(value, max$1));
}
function withinMaxClamp(min2, value, max2) {
  var v = within(min2, value, max2);
  return v > max2 ? max2 : v;
}
export {
  within,
  withinMaxClamp
};
//# sourceMappingURL=within.es.js.map
